import React from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const DispatchChoiceModal = ({open, onClose, onDispatch, onAssignment, title = "Selecione uma ação"}) => (
    <Modal open={open} setOpen={onClose} title={title} className="w-full max-w-[500px]" isCloseClick={false}>
        <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto !px-4 !py-3">
            <div className="flex items-stretch justify-center">
                <button
                    type="button"
                    onClick={onDispatch}
                    className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-4 rounded-lg px-4 py-6 text-[#666a6d] transition-colors duration-150 hover:bg-[#f2f2f2] hover:text-[#4a4d50]"
                >
                    <img
                        src={getAssetPath("img/dispatch-dashboard-svg/sw-dispatch.svg")}
                        alt=""
                        className="h-18 w-18 object-contain"
                        aria-hidden="true"
                    />
                    <span className="text-[1.15rem] font-medium">Despachar</span>
                </button>

                <div className="mx-4 w-px self-stretch bg-[#e6e6e6]" aria-hidden="true"/>

                <button
                    type="button"
                    onClick={onAssignment}
                    className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-4 rounded-lg px-4 py-6 text-[#666a6d] transition-colors duration-150 hover:bg-[#f2f2f2] hover:text-[#4a4d50]"
                >
                    <img
                        src={getAssetPath("img/dispatch-dashboard-svg/sw-assignment.svg")}
                        alt=""
                        className="h-18 w-18 object-contain"
                        aria-hidden="true"
                    />
                    <span className="text-[1.15rem] font-medium">Atribuir</span>
                </button>
            </div>
        </Modal.Body>
    </Modal>
);

export default DispatchChoiceModal;
